import { render, staticRenderFns } from "./DispatchIndex.vue?vue&type=template&id=d1002bd2"
import script from "./DispatchIndex.vue?vue&type=script&lang=js"
export * from "./DispatchIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports